import { Box, Button, Checkbox, Heading, Icon, IconButton, Input, ListItem, Menu, MenuButton, MenuItem, MenuList, OrderedList, Radio, RadioGroup, Select, SimpleGrid, Stack, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { FaArrowLeft, FaArrowRight, FaCalendar, FaCheck, FaCloudUploadAlt, FaCreditCard, FaDownload, FaEdit, FaFileExcel, FaFileInvoice, FaFilter, FaHistory, FaPlus, FaSave, FaSearch, FaSync, FaTrash, FaUndo } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { TbArrowsLeftRight, TbFileInvoice } from "react-icons/tb";
import SwitchButton from "../../../components/Buttons/SwitchButton";
import SpreadsheetTable from "../../../components/Tables/SpreadsheetTable";

export default function BankStatements() {
    const [items] = useState([
        {
            id: 1,
            name: "Star Trek Voucher😂"
        },
        {
            id: 2,
            name: "Inam Neil Degrasse Tyson Voucher"
        },
        {
            id: 3,
            name: "Bank Payment Voucher",
        },
        {
            id: 4,
            name: "Cigarette Expense Voucher",
        },
        {
            id: 5,
            name: "Purchase Invoice",
        },
        {
            id: 6,
            name: "Refund Document",
        },
    ]);
    
    function onResize() {
        if (window.innerWidth >= 1024 && window.innerWidth < 1366) {
            return '2xl';
        } else if (window.innerWidth >= 1366 && window.innerWidth < 1440) {
            return '3xl';
        } else if (window.innerWidth >= 1440 && window.innerWidth < 1600) {
            return '4xl';
        } else if (window.innerWidth >= 1600 && window.innerWidth < 1920) {
            return '6xl';
        } else if (window.innerWidth >= 1920) {
            return '8xl';
        }
    }

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'} justify={'start'} align={'center'}>
                        <Icon
                            as={TbFileInvoice}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Bank Statements</Heading>
                            <SimpleGrid templateColumns={'1fr 1fr 1fr'}>
                                <Text>Name: <strong>EBTest</strong></Text>
                                <Text>Industry: <strong>Accountancy Firm</strong></Text>
                                <Text>Country: <strong>Pakistan</strong></Text>
                                <Text>Credit: <strong>-18</strong></Text>
                                <Text>Software: <strong>Other (Excel Output)</strong></Text>
                                <Text>Duplicate: <strong>Flag</strong></Text>
                                <Text>VAT: <strong>Registered</strong></Text>
                                <Text>VAT Scheme: <strong>Accrual Scheme</strong></Text>
                                <Text>Subscription Status: <strong>In Trial</strong></Text>
                                <Text>Subscription Plan: <strong>Standard</strong></Text>
                                <Text>Processing Status: <strong>Active</strong></Text>
                                <Text>Data Entry By: <strong>Someone</strong></Text>
                                <Text>Data Entry Time: <strong></strong></Text>
                                <Text>Parent Doc ID: <strong></strong></Text>
                            </SimpleGrid>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', "2xl": 'flex-end' }} direction={'row'} spacing={4}>
                    <IconButton
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        icon={<FaDownload />}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                        aria-label="Download Statement Format"
                    />

                    <Button
                        size={'sm'}
                        leftIcon={<FaSearch />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        AWS
                    </Button>

                    <Button
                        size={'sm'}
                        leftIcon={<FaFileExcel />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Upload Excel
                    </Button>


                    <Button
                        size={'sm'}
                        leftIcon={<FaCloudUploadAlt />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Upload
                    </Button>

                    <Button
                        size={'sm'}
                        leftIcon={<FaFilter />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Header
                    </Button>

                    <IconButton
                        size={'sm'}
                        color={'white'}
                        bg={'gray.400'}
                        icon={<GiHamburgerMenu />}
                        _hover={{ bg: 'gray.400' }}
                        _active={{ bg: 'gray.400' }}
                        aria-label="Hamburger Menu"
                    />
                </Stack>
            </Stack>

            <Stack
                p={4}
                w={'98%'}
                spacing={4}
                rounded={'xl'}
                boxShadow={'base'}
            >
                <Stack
                    align={'flex-end'}
                    direction={{ md: 'column', lg: 'row' }}
                >
                    <Stack
                        w={'full'}
                        spacing={0.5}
                    >
                        <Stack
                            w={'full'}
                            spacing={1}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <IconButton
                                aria-label="Add Payment Method"
                                _hover={{ bg: 'primary.400', color: 'white' }}
                                _active={{ bg: 'primary.700', color: 'white' }}
                                rounded={'none'}
                                size={'xs'}
                                icon={<FaPlus />}
                            />
                            <IconButton
                                aria-label="Edit Payment Method"
                                _hover={{ bg: 'primary.400', color: 'white' }}
                                _active={{ bg: 'primary.700', color: 'white' }}
                                rounded={'none'}
                                size={'xs'}
                                icon={<FaEdit />}
                            />
                            <IconButton
                                aria-label="Search Payment Method"
                                _hover={{ bg: 'primary.400', color: 'white' }}
                                _active={{ bg: 'primary.700', color: 'white' }}
                                rounded={'none'}
                                size={'xs'}
                                icon={<FaSearch />}
                            />
                        </Stack>
                        <Input
                            w={'full'}
                            size={'sm'}
                            type={'text'}
                            placeholder='Payment Method'
                            disabled
                        />
                    </Stack>
                    <Input
                        w={'100%'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Account No'
                        disabled
                    />

                    <Select
                        w={'full'}
                        size={'sm'}
                        placeholder="Doc Type"
                    >
                        <option value="option1">BPV</option>
                        <option value="option1">Credit Note</option>
                    </Select>

                    <Stack
                        w={'full'}
                        spacing={0.5}
                    >
                        <Stack
                            w={'full'}
                            spacing={1}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <Button
                                leftIcon={<FaPlus />}
                                _hover={{ bg: 'primary.400', color: 'white' }}
                                _active={{ bg: 'primary.700', color: 'white' }}
                                rounded={'none'}
                                size={'xs'}
                                w={'fit-content'}
                            >
                                TRN DT
                            </Button>
                        </Stack>
                        <Input
                            w={'full'}
                            size={'sm'}
                            type={'date'}
                            placeholder='Start Date'
                        />
                    </Stack>

                    <Select
                        w={'full'}
                        size={'sm'}
                        placeholder="Movement Type"
                    >
                        <option value="option1">Single Column</option>
                        <option value="option2">Double Column</option>
                    </Select>

                    <Stack
                        w={'full'}
                        spacing={0.5}
                    >
                        <Stack
                            w={'full'}
                            spacing={1}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <Checkbox size='sm' fontSize={'xs'} colorScheme='primary'>
                                Opening Bal.
                            </Checkbox>
                        </Stack>
                        <Input
                            w={'full'}
                            size={'sm'}
                            type={'text'}
                            placeholder='Opening Balance'
                        />
                    </Stack>

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'number'}
                        placeholder='Money In'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'number'}
                        placeholder='Money Out'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'number'}
                        placeholder='Net Money In/Out'
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'number'}
                        placeholder='Closing Balance'
                    />
                </Stack>

                <Stack
                    align={'flex-end'}
                    direction={{ md: 'column', lg: 'row' }}
                >
                    <Stack
                        w={'full'}
                        spacing={0.5}
                    >
                        <Stack
                            w={'full'}
                            spacing={1}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <IconButton
                                aria-label="Account History"
                                _hover={{ bg: 'primary.400', color: 'white' }}
                                _active={{ bg: 'primary.700', color: 'white' }}
                                rounded={'none'}
                                size={'xs'}
                                icon={<FaHistory />}
                            />
                            <IconButton
                                aria-label="Search Account No"
                                _hover={{ bg: 'primary.400', color: 'white' }}
                                _active={{ bg: 'primary.700', color: 'white' }}
                                rounded={'none'}
                                size={'xs'}
                                icon={<FaSearch />}
                            />
                        </Stack>
                        <Input
                            w={'full'}
                            size={'sm'}
                            type={'text'}
                            placeholder='Account info'
                        />
                    </Stack>
                    <Input
                        w={'100%'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Payment Method Type'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'date'}
                        placeholder='End Date'
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Last Saved By'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Opening Balance'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Money In'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Money Out'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Net Money In/Out'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Closing Balance'
                        disabled
                    />
                </Stack>

                <Stack
                    w={'full'}
                    align={'flex-end'}
                    direction={{ md: 'column', lg: 'row' }}
                >
                    <Input
                        w={'100%'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Payment Currency'
                        disabled
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'text'}
                        placeholder='Chargeable Pages'
                    />

                    <Select
                        w={'full'}
                        size={'sm'}
                        placeholder={'Select Comment'}
                    >
                        <option value={'option1'}>Nothing Selected</option>
                        <option value={'option1'}>Something Selected</option>
                    </Select>
                </Stack>

                <Stack
                    w={'full'}
                    align={'flex-end'}
                    direction={{ md: 'column', lg: 'row' }}
                >
                    <Textarea
                        w={'full'}
                        size={'sm'}
                        resize={'none'}
                        rounded={'none'}
                        placeholder={"Processing Comment"}
                    ></Textarea>

                    <Textarea
                        w={'full'}
                        size={'sm'}
                        resize={'none'}
                        rounded={'none'}
                        placeholder={"Redo Comment"}
                        disabled
                    ></Textarea>

                    <Textarea
                        w={'full'}
                        size={'sm'}
                        resize={'none'}
                        rounded={'none'}
                        placeholder={"Rejeck Remarks"}
                        disabled
                    ></Textarea>
                </Stack>

                <Stack
                    w={'full'}
                    align={'flex-end'}
                    direction={{ md: 'column', lg: 'row' }}
                >
                    <Button
                        w={'full'}
                        size={'sm'}
                        leftIcon={<FaSync />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Update Seq
                    </Button>
                    <Button
                        w={'full'}
                        size={'sm'}
                        leftIcon={<TbArrowsLeftRight />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Swap Dr/Cr
                    </Button>
                    <SwitchButton
                        size={'sm'}
                        firstButtonText="ASC"
                        secondButtonText="DESC"
                        activeButtonColor={'green.500'}
                        activeHoverColor={'green.600'}
                        activeClickColor={'green.700'}
                        inactiveButtonColor={'gray.400'}
                        inactiveHoverColor={'gray.500'}
                        inactiveClickColor={'gray.600'}
                        color={'white'}
                    />
                    <Button
                        w={'full'}
                        size={'sm'}
                        leftIcon={<FaUndo />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Recalculate
                    </Button>
                    <Button
                        w={'full'}
                        size={'sm'}
                        leftIcon={<FaHistory />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        History
                    </Button>
                    <Button
                        w={'full'}
                        size={'sm'}
                        leftIcon={<FaCheck />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Processed
                    </Button>
                    <Button
                        w={'full'}
                        size={'sm'}
                        leftIcon={<FaSave />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Save
                    </Button>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <SimpleGrid
                    templateColumns={{ base: '1fr', md: '1fr 3fr 3fr' }}
                    spacing={6}
                >
                    <Stack spacing={1}>
                        <Stack
                            w={'fit-content'}
                        >
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    colorScheme={'red'}
                                    rightIcon={<BsChevronDown />}
                                >
                                    Bulk Delete
                                </MenuButton>
                                <MenuList>
                                    <MenuItem>Delete All</MenuItem>
                                    <MenuItem>Delete Selected</MenuItem>
                                </MenuList>
                            </Menu>
                        </Stack>
                        <TableContainer>
                            <Table size='sm'>
                                <Thead h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                                    <Tr>
                                        <Th></Th>
                                        <Th
                                            color={'white'}
                                            isNumeric
                                        >
                                            ID
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        items.map(item => (
                                            <Tr>
                                                <Td
                                                >
                                                    <Checkbox
                                                        colorScheme='primary'
                                                    />
                                                </Td>
                                                <Td
                                                    isNumeric
                                                >
                                                    {item.id}
                                                </Td>
                                            </Tr>
                                        ))
                                    }
                                    {/* <Tr>
                                        <Td colSpan={2} textAlign={'center'}>There is no document in this folder</Td>
                                    </Tr> */}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Stack>
                    <Stack>
                        <Stack
                            w={'full'}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <IconButton
                                aria-label="Right"
                                colorScheme={'orange'}
                                icon={<FaArrowLeft />}
                            />
                            <IconButton
                                aria-label="Right"
                                colorScheme={'orange'}
                                icon={<FaArrowRight />}
                            />
                        </Stack>
                        <Stack w={'full'} h={'full'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                            <Heading color={'white'}>PDF Viewer Here</Heading>
                            <Text color={'whiteAlpha.900'}>I'm currently thinking about creating a dynamic method <br /> for PDFs and Document Viewer <br /> I'll update the document viewer once, I find a solution for that</Text>
                        </Stack>
                    </Stack>
                    <Stack
                        w={'full'}
                        spacing={2}
                    >
                        <Stack
                            w={'full'}
                            align={'center'}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <RadioGroup size={'md'} colorScheme={'primary'}>
                                <Stack direction='row'>
                                    <Radio value='1'>INV</Radio>
                                    <Radio value='2'>DOC</Radio>
                                    <Radio value='3'>MS</Radio>
                                </Stack>
                            </RadioGroup>
                            <Button
                                color={'white'}
                                bg={'primary.400'}
                                leftIcon={<FaFileInvoice />}
                                _hover={{ bg: 'primary.500' }}
                                _active={{ bg: 'primary.600' }}
                            >
                                Reclassify
                            </Button>
                            <Button
                                color={'white'}
                                bg={'red.500'}
                                leftIcon={<FaTrash />}
                                _hover={{ bg: 'red.500' }}
                                _active={{ bg: 'red.600' }}
                            >
                                Delete
                            </Button>
                            <Button
                                color={'white'}
                                bg={'red.500'}
                                leftIcon={<FaDownload />}
                                _hover={{ bg: 'red.500' }}
                                _active={{ bg: 'red.600' }}
                            >
                                Download XLSX
                            </Button>
                        </Stack>
                        <Stack
                            w={'full'}
                            align={'center'}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <Button
                                color={'white'}
                                bg={'primary.400'}
                                leftIcon={<FaCalendar />}
                                _hover={{ bg: 'primary.500' }}
                                _active={{ bg: 'primary.600' }}
                            >
                                Highlight By Transaction Date
                            </Button>
                            <Button
                                color={'white'}
                                bg={'blue.400'}
                                leftIcon={<FaCreditCard />}
                                _hover={{ bg: 'blue.500' }}
                                _active={{ bg: 'blue.600' }}
                            >
                                Highlight By Sub Reference
                            </Button>
                        </Stack>
                        <Stack
                            w={'full'}
                            spacing={4}
                        >
                            <Stack
                                w={'full'}
                            >
                                <SpreadsheetTable
                                    w={onResize()}
                                    tableHeight={'250px'}
                                    data={[
                                        [],
                                        [],
                                        []
                                    ]}
                                    columns={[
                                        { title: 'Seq (B)', width: 50, type: "numeric" },
                                        { title: 'Date (C)', width: 80, type: "calendar" },
                                        { title: 'Description (D)', width: 100, type: "text" },
                                        { title: "Ref (E)", width: 100, type: "text" },
                                        { title: "Money Out (F)", width: 50, type: "numeric" },
                                        { title: "Money In (G)", width: 50, type: "numeric" },
                                        { title: "Scan Bal (H)", width: 50, type: "numeric" },
                                        { title: "Calculated Bal (I)", width: 50, type: "numeric" },
                                        { title: "Difference (J)", width: 50, type: "numeric" },
                                        { title: "Sub Account Ref (K)", width: 70, type: "text" },
                                        { title: "Memo Amount 1 (L)", width: 50, type: "numeric" },
                                        { title: "Memo Amount 2 (M)", width: 50, type: "numeric" },
                                    ]}
                                />
                            </Stack>
                            <Stack
                                spacing={2}
                            >
                                <Heading fontSize={'2xl'}>Legends</Heading>
                                <OrderedList px={4} spacing={2}>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>This date is not a valid date (Dark Salmon Background Color)</Text>
                                            <Box w={'20px'} h={'20px'} bg={'#E9967A'}></Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>Wrong Sequence</Text>
                                            <Box w={'20px'} h={'20px'} bg={'red.500'}></Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>Money Out and In cannot be zero at the same time</Text>
                                            <Box w={'20px'} h={'20px'} bg={'crimson.500'}></Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>Date not in date range</Text>
                                            <Box w={'20px'} h={'20px'} bg={'orange.500'}></Box>
                                            <Text size={'sm'}>OR</Text>
                                            <Box w={'20px'} h={'20px'} border={'2px'} borderColor={'red.600'}></Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>Incorrect sorting based on selection (ASC/DESC)</Text>
                                            <Box w={'20px'} h={'20px'} bg={'yellow.500'}></Box>
                                            <Text size={'sm'}>OR</Text>
                                            <Text color={'red.500'} size={'sm'}>Red Text</Text>
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>The difference b/w calculated and scanned balance is greater than 0.03</Text>
                                            <Box w={'20px'} h={'20px'} bg={'pink.500'}></Box>
                                            <Text size={'sm'}>OR</Text>
                                            <Text size={'sm'} color={'red.500'}>Red Text</Text>
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            align={'center'}
                                        >
                                            <Text size={'sm'}>Both Money In and Money Out appears in the same row (Fire Brick Background Color)</Text>
                                            <Box w={'20px'} h={'20px'} bg={'#B22222'}></Box>
                                        </Stack>
                                    </ListItem>
                                </OrderedList>
                            </Stack>
                        </Stack>
                    </Stack>
                </SimpleGrid>
            </Stack>
        </Stack >
    )
}